import React from "react";
import { Box, Paper, Stack, Typography, Tab, Tabs } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const ColoredTab = () => {
  const [value, setValue] = React.useState("one");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Colored tab
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"              <Tabs\n" +
              "                value={value}\n" +
              "                onChange={handleChange}\n" +
              "                textColor=\"secondary\"\n" +
              "                indicatorColor=\"secondary\"\n" +
              "                aria-label=\"secondary tabs example\"\n" +
              "              >\n" +
              "                <Tab value=\"one\" label=\"Item One\" />\n" +
              "                <Tab value=\"two\" label=\"Item Two\" />\n" +
              "                <Tab value=\"three\" label=\"Item Three\" />\n" +
              "              </Tabs>"}>
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
              >
                <Tab value="one" label="Item One" />
                <Tab value="two" label="Item Two" />
                <Tab value="three" label="Item Three" />
              </Tabs>
            </Box>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default ColoredTab;
